import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import InputText from 'LuxKit/Typography/InputText'

const TextInputContainer = styled.label`
  display: block;
`

const LabelText = styled(InputText)`
  display: block;

  & + * {
    margin-top: ${rem(4)};
  }
`

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  label?: React.ReactNode
  required?: boolean
  optionalIndicatorEnabled?: boolean
}

const InputLabelWrap = React.forwardRef<HTMLLabelElement, Props>((props, ref) => {
  const {
    label,
    children,
    required,
    optionalIndicatorEnabled = true,
    ...labelProps
  } = props

  const intl = useIntl()

  const optionalLabel = intl.formatMessage({
    id: 'bXDB0A5jgp445ALgR591',
    defaultMessage: '(optional)',
    description: 'Indicator shown next to form fields that are not required',
  })

  const showOptional = !required && optionalIndicatorEnabled

  const labelWithOptional = <FormattedMessage
    id="ZzMm8UVJ4Bvw6gNEkVFc"
    defaultMessage="{label} {optionalIndicator}"
    description="Form field label text followed by an optional field indicator for non-required inputs"
    values={{
      label,
      optionalIndicator: <InputText as="span" variant="sub-label">{optionalLabel}</InputText>,
    }}
  />

  return (
    <TextInputContainer {...labelProps} ref={ref}>
      {label && <LabelText variant="label">
        {showOptional ? labelWithOptional : label}
      </LabelText>}
      {children}
    </TextInputContainer>
  )
})

InputLabelWrap.displayName = 'InputLabelWrap'

export default InputLabelWrap
